import * as React from 'react'

import { CompassIcon } from './CompassIcon'
import MapControlButton from './MapControlButton'

interface ICompassButtonProps {
  bearing: number
  onResetNorth: () => void
}

const CompassButton: React.FC<ICompassButtonProps> = ({
  bearing,
  onResetNorth,
}) => (
  <MapControlButton onClick={onResetNorth} title="Reset North">
    <div
      className="tw:flex tw:items-center tw:justify-center"
      style={{ transform: `rotate(${-bearing}deg)` }}
    >
      <CompassIcon size={28} className="tw:size-7" />
    </div>
  </MapControlButton>
)

export default CompassButton
